import { BrandingApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const brandingApi = BrandingApi({}, '/api', axiosInstance);
